import React from 'react'
import Carousel, { consts } from 'react-elastic-carousel'
import { useTheme } from '@emotion/react'
import SlideArrow from '../../atoms/SlideArrow'

import { ElasticCarouselStyled, ArrowContainerStyled } from './styles'

const Slider = ({ config, children, isAlt }) => {
  const theme = useTheme()

  const slideArrow = ({ type, onClick, isEdge }) => {
    const classesPrev = `rec-arrow rec-arrow-prev`
    const classesNext = `rec-arrow rec-arrow-next`

    const pointer =
      type === consts.PREV ? (
        <div className={classesPrev}>
          <SlideArrow isRotated />
        </div>
      ) : (
        <div className={classesNext}>
          <SlideArrow />
        </div>
      )
    return (
      <ArrowContainerStyled onClick={onClick} disabled={isEdge} className="rec-arrow-item">
        {pointer}
      </ArrowContainerStyled>
    )
  }

  const slideArrowSmall = ({ type, onClick, isEdge }) => {
    const classesPrev = `rec-arrow rec-arrow-prev`
    const classesNext = `rec-arrow rec-arrow-next`

    const pointer =
      type === consts.PREV ? (
        <div className={classesPrev}>
          <SlideArrow isSmall isRotated />
        </div>
      ) : (
        <div className={classesNext}>
          <SlideArrow isSmall />
        </div>
      )
    return (
      <ArrowContainerStyled onClick={onClick} disabled={isEdge} className="rec-arrow-item">
        {pointer}
      </ArrowContainerStyled>
    )
  }

  return (
    <ElasticCarouselStyled {...{ isAlt }}>
      <Carousel isRTL={theme.direction === 'rtl' ? true : false} renderArrow={isAlt ? slideArrowSmall : slideArrow} breakPoints={config}>
        {children}
      </Carousel>
    </ElasticCarouselStyled>
  )
}

export default Slider
